<!-- src/app/settings/accruals/components/create-leave-policy-modal/create-leave-policy-modal.component.html -->

<div *ngIf="open" class="modal-backdrop" (click)="onBackdropClick()">
  <div class="modal" (click)="$event.stopPropagation()">
    <h2>Create Leave Policy</h2>

    <p class="modal-text">
      Create a new accrual policy for vacation or sick time. Weekly accrual day is only required for weekly policies.
    </p>

    <form #policyForm="ngForm" (ngSubmit)="submit(policyForm)">
      <!-- Policy Name -->
      <div class="form-field">
        <label for="name">Policy Name</label>
        <input
          id="name"
          type="text"
          name="name"
          [(ngModel)]="formModel.name"
          #nameModel="ngModel"
          required
          maxlength="100"
          placeholder="Enter policy name"
        />
        <div class="field-error" *ngIf="submitted && nameModel.invalid">
          Policy name is required.
        </div>
      </div>

      <!-- Leave Type -->
      <div class="form-field">
        <label for="leaveType">Leave Type</label>
        <select
          id="leaveType"
          name="leaveType"
          [(ngModel)]="formModel.leaveType"
          #leaveTypeModel="ngModel"
          required
        >
          <option [ngValue]="null" disabled>Select leave type</option>
          <option *ngFor="let type of leaveTypeOptions" [ngValue]="type">
            {{ type }}
          </option>
        </select>
        <div class="field-error" *ngIf="submitted && leaveTypeModel.invalid">
          Leave type is required.
        </div>
      </div>

      <!-- Accrual Frequency -->
      <div class="form-field">
        <label for="accrualFrequency">Accrual Frequency</label>
        <select
          id="accrualFrequency"
          name="accrualFrequency"
          [(ngModel)]="formModel.accrualFrequency"
          #accrualFrequencyModel="ngModel"
          (ngModelChange)="onAccrualFrequencyChange($event)"
          required
        >
          <option [ngValue]="null" disabled>Select accrual frequency</option>
          <option *ngFor="let frequency of accrualFrequencyOptions" [ngValue]="frequency">
            {{ frequency }}
          </option>
        </select>
        <div class="field-error" *ngIf="submitted && accrualFrequencyModel.invalid">
          Accrual frequency is required.
        </div>
      </div>

      <!-- Weekly Accrual Day -->
      <div class="form-field" *ngIf="showWeeklyAccrualDay">
        <label for="weeklyAccrualDay">Weekly Accrual Day</label>
        <select
          id="weeklyAccrualDay"
          name="weeklyAccrualDay"
          [(ngModel)]="formModel.weeklyAccrualDay"
          #weeklyAccrualDayModel="ngModel"
          [required]="showWeeklyAccrualDay"
        >
          <option [ngValue]="null" disabled>Select accrual day</option>
          <option *ngFor="let day of weekDayOptions" [ngValue]="day.value">
            {{ day.label }}
          </option>
        </select>
        <div class="field-error" *ngIf="submitted && weeklyAccrualDayModel.invalid">
          Weekly accrual day is required for weekly policies.
        </div>
      </div>

      <!-- Hours Per Year -->
      <div class="form-field">
        <label for="hoursPerYear">Hours Per Year</label>
        <input
          id="hoursPerYear"
          type="number"
          name="hoursPerYear"
          [(ngModel)]="formModel.hoursPerYear"
          #hoursPerYearModel="ngModel"
          required
          min="0"
          step="0.5"
          placeholder="0.00"
        />
        <div class="field-error" *ngIf="submitted && hoursPerYearModel.invalid">
          Enter a valid yearly hours amount.
        </div>
      </div>

      <!-- Max Balance -->
      <div class="form-field">
        <label for="maxBalance">Max Balance</label>
        <input
          id="maxBalance"
          type="number"
          name="maxBalance"
          [(ngModel)]="formModel.maxBalance"
          #maxBalanceModel="ngModel"
          required
          min="0"
          step="0.5"
          placeholder="0.00"
        />
        <div class="field-error" *ngIf="submitted && maxBalanceModel.invalid">
          Enter a valid max balance.
        </div>
      </div>

      <!-- Max Carry Over -->
      <div class="form-field">
        <label for="maxCarryOver">Max Carry Over</label>
        <input
          id="maxCarryOver"
          type="number"
          name="maxCarryOver"
          [(ngModel)]="formModel.maxCarryOver"
          #maxCarryOverModel="ngModel"
          required
          min="0"
          step="0.5"
          placeholder="0.00"
        />
        <div class="field-error" *ngIf="submitted && maxCarryOverModel.invalid">
          Enter a valid carry over amount.
        </div>
      </div>

      <!-- Allow Negative Balance -->
      <div class="form-field">
        <label for="allowNegativeBalance">Allow Negative Balance</label>
        <select
          id="allowNegativeBalance"
          name="allowNegativeBalance"
          [(ngModel)]="formModel.allowNegativeBalance"
        >
          <option value="false">No</option>
          <option value="true">Yes</option>
        </select>
      </div>

      <!-- Buttons -->
      <div class="modal-buttons">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="handleClose()"
          [disabled]="isSaving"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="isSaving"
        >
          {{ isSaving ? 'Saving...' : 'Create Policy' }}
        </button>
      </div>
    </form>
  </div>
</div>